import { generateBaseQueryKeysList } from '@/queries/utils';

export const REGIONS_KEYS = {
  main: 'regions',
  serviceRegions: 'service-regions',
};

export const regionsQueryKeys = generateBaseQueryKeysList(REGIONS_KEYS.main);
export const serviceRegionsQueryKeys = generateBaseQueryKeysList(REGIONS_KEYS.serviceRegions);
